/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_SessionInputs */

const en_loading_session = /** @type {(inputs: Loading_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking your session…`)
};

const id_loading_session = /** @type {(inputs: Loading_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memeriksa sesi masuk…`)
};

/**
* | output |
* | --- |
* | "Checking your session…" |
*
* @param {Loading_SessionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_session = /** @type {((inputs?: Loading_SessionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_SessionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_session(inputs)
	return en_loading_session(inputs)
});